import { render, staticRenderFns } from "./EdenOverviewCard.vue?vue&type=template&id=2a4bfe70&scoped=true"
import script from "./EdenOverviewCard.vue?vue&type=script&lang=js"
export * from "./EdenOverviewCard.vue?vue&type=script&lang=js"
import style0 from "./EdenOverviewCard.vue?vue&type=style&index=0&id=2a4bfe70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4bfe70",
  null
  
)

export default component.exports